import { matchPath } from 'react-router-dom';
import { createSelector } from 'reselect';
import { appRoutes } from 'routes';
import { trimEnd } from 'lodash-es';

import { urlChannelIdSelector, urlChannelSlugSelector } from 'pages/channel.page';
import { getVideoIdSelector } from 'components/video-box/selectors';
import { isIframe } from 'integration/integration.utils';
import { integrationSelector } from 'common/selectors';

export const getSharePathSelector = (params) => (state) => {
  const isChannel = matchPath(window.location.pathname, {
    path: appRoutes.channel,
    exact: true,
  });

  return isChannel ? getChannelPathSelector(params)(state) : getVideoPathSelector(state);
};

export const getBase64SharePathSelector = (params) => (state) => {
  const path = getSharePathSelector(params)(state);
  const videoId = getVideoIdSelector(state);

  return btoa(JSON.stringify({ video: videoId, path }));
};

const getChannelPathSelector = (params) => (state) => {
  const integration = integrationSelector(state);
  const videoId = getVideoIdSelector(state);
  const channelId = urlChannelIdSelector(params)(state);
  const channelSlug = urlChannelSlugSelector(state, params);
  const basePath = getBasePath(integration);

  return `${basePath}/channel/${channelId}/${channelSlug}/1/${videoId}`;
};

const getVideoPathSelector = createSelector(getVideoIdSelector, integrationSelector, (videoId, integration) => {
  return `${getBasePath(integration)}/video/${videoId}`;
});

const getBasePath = (integration) =>
  isIframe(integration) ? `${trimEnd(integration.portalUrl, '/')}/?ct-pathname=` : trimEnd(window.location.origin, '/');
